import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export type AirConInfoRecoil = {
    airConID: string,
    airConLocation: string,
    airConState: boolean,
    currentTemp: number,
    raiseTemp: number,
    lowerTemp: number
}

export const headerIndexState = atom<number>({
    key: "headerIndexState",
    default: 0,
    effects_UNSTABLE: [persistAtom],
})
